import { Suspense, useState } from 'react';
import { Container, Row, Col, Button, Navbar } from 'react-bootstrap';

import { useKeycloak } from '@react-keycloak/web';

import PatientList from './PatientList';
import LoadingSpinner from '../Components/LoadingSpinner';
import { APP_TITLE, ADMINISTRATION, LOG_OUT, EXIT_ADMINISTRATION } from '../util/const';
import Administration from './Administration';


const Dashboard = () => {

  const [admin, setAdmin] = useState(false);
  const toggleAdmin = () =>
  {
    setAdmin(!admin);
  }

  const { keycloak } = useKeycloak();
  
  const handleLogout = () => {
    keycloak.logout();
  }

  return(
    <Container fluid>
      <Row>
        <Col>
          <Navbar className="bg-body-tertiary">
            <Container fluid>
              <Navbar.Brand href={process.env.REACT_APP_URL as string}>
                <img
                  alt=""
                  src="/img/logo.svg"
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
                />{' '}
                {APP_TITLE}
              </Navbar.Brand>
              <Navbar.Toggle />
              <Navbar.Collapse className="justify-content-end">
                <Navbar.Text>
                  <Button onClick={toggleAdmin} className='outline-button me-3'>
                    {!admin ? ADMINISTRATION : EXIT_ADMINISTRATION}
                  </Button>
                </Navbar.Text>
                <Navbar.Text>
                  <Button onClick={handleLogout} className='outline-button'>
                    {LOG_OUT}
                  </Button>
                </Navbar.Text>
              </Navbar.Collapse>
            </Container>
          </Navbar>
          <Suspense fallback={<LoadingSpinner />}>
          {
            admin ? <Administration /> : <PatientList />
          }
          </Suspense>
        </Col>
      </Row>
    </Container>
  );
}

export default Dashboard;